export const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const formattedDate = date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const isMidnight =
    (date.getHours() === 1 &&
      date.getMinutes() === 0 &&
      date.getSeconds() === 0) ||
    (date.getHours() === 2 &&
      date.getMinutes() === 0 &&
      date.getSeconds() === 0);

  if (isMidnight) return formattedDate;

  const formattedTime = date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return `${formattedDate} à ${formattedTime}`;
};
